import { render, staticRenderFns } from "./barren.vue?vue&type=template&id=50e543e0&"
import script from "./barren.vue?vue&type=script&lang=js&"
export * from "./barren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports